import WorkerServices from './WorkerServices';

export default WorkerServices;
